import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

import { SummaryItemComponent } from 'shared/components/summary-item/summary-item.component';

import { IDENTITY_DOCUMENT_TYPES } from '../../../modules/admin/customers/translations/customers-select-items';
import { CountryNamePipe } from '../../pipes/country-name.pipe';
import { SectionWrapperComponent } from '../containers/section-wrapper-container/section-wrapper-container.component';
import { GetTranslationKeyForValuePipe } from '../dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';

@Component({
	selector: 'app-driver-overview-card',
	templateUrl: 'driver-overview-card.component.html',
	imports: [
		SectionWrapperComponent,
		TranslocoModule,
		SummaryItemComponent,
		DatePipe,
		GetTranslationKeyForValuePipe,
		NgTemplateOutlet,
		CountryNamePipe,
	],
	standalone: true,
})
export class DriverOverviewCardComponent<T> {
	recordData = input<T>();
	idTypes = IDENTITY_DOCUMENT_TYPES;
}
